<div class="background-blue">
  <div class="page-title-container container">
    <h1 style="font-size: 22.5px"><adp-label labelKey="FAQ_SPOE_P360_Heading_Text"></adp-label></h1>
  </div>
</div>
<div class="container faq-container">
  <!--<div class="faq-selected-title">{{selectedNavItemTitle}}</div>-->
  <div class="faq-inner-container">
    <div class="d-block d-lg-none" *ngIf="isMobile" style="width: 100%">
      <div class="mobile-nav-select">
        <mat-select
          *ngIf="faqNavKeys?.length"
          [(value)]="selectedNavKey"
          (selectionChange)="getFaqItems($event.value)"
          disableOptionCentering>
          <mat-select-trigger>
            <div class="d-flex align-items-center menu-selected">
              <mat-icon class="selected-icon" [svgIcon]="getFaqIcon(selectedNavKey)"></mat-icon>
              <p class="menu-selected-text">{{ getFaqNavLabel(selectedNavKey) }}</p>
              <mat-icon class="arrow-down-right" [svgIcon]="'chevron-down'"></mat-icon>
            </div>
          </mat-select-trigger>
          <mat-option *ngFor="let item of faqNavKeys | pghOrderBy: order : ascending" [value]="item" [gtmClick]="getFaqNavLabel(item)">
            <div class="d-flex align-items-center menu-option-items">
              <mat-icon [svgIcon]="getFaqIcon(item)"></mat-icon>
              <adp-label [labelKey]="'FAQ_Nav_List_' + item"></adp-label>
            </div>
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row d-none d-lg-block" *ngIf="!isMobile">
      <div class="col-12 d-inline-flex">
        <nav mat-tab-nav-bar class="menu-border mr-20">
          <a
            mat-tab-link
            *ngFor="let item of faqNavKeys"
            (click)="getFaqItems(item)"
            (keypress)="handleKeyPress($event, item)"
            [active]="selectedNavKey == item"
            [ngClass]="selectedNavKey == item ? 'menu-active theme-primary-menu-color' : ''"
            [gtmClick]="getFaqNavLabel(item)">
            <mat-icon [svgIcon]="getFaqIcon(item)" [ngClass]="selectedNavKey == item ? 'theme-primary-icon-color' : ''"></mat-icon>
            <adp-label [labelKey]="'FAQ_Nav_List_' + item" [ngClass]="selectedNavKey == item ? 'theme-primary-menu-color' : ''"></adp-label>
          </a>
        </nav>
      </div>
    </div>
    <div class="faq-list-container">
      <mat-accordion *ngIf="faqListItems?.length > 0">
        <mat-expansion-panel
          displayMode="flat"
          hideToggle
          *ngFor="let faqItem of faqListItems; let i = index"
          (opened)="setOpened(i)"
          (closed)="setClosed(i)"
          class="faq-item-container"
          [gtmClick]="getFaqItemQuestion(faqItem.questionKey)"
          gtmEventCategory="accordion_expand"
          [gtmLinkClasses]="selectedNavItemTitle">
          <mat-expansion-panel-header class="faq-question-container">
            <mat-panel-title>
              <mat-icon class="faq-icon-container" [svgIcon]="currentlyOpenedItemIndex === i ? 'subtract' : 'add'"></mat-icon>
              <span class="faq-question"><adp-label labelKey="{{ faqItem.questionKey }}"></adp-label></span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="faq-answer-container">
            <div class="faq-answer" *ngIf="faqItem.answerKey !== faqReplacementDeviceP360Answer3Key"><adp-label labelKey="{{ faqItem.answerKey }}"></adp-label></div>
            <div class="faq-answer" *ngIf="faqItem.answerKey === faqReplacementDeviceP360Answer3Key">
              <adp-label labelKey="{{ faqItem.answerKey }}"></adp-label><button type="button" class="link" style="padding:0px;" (click)="openASAPPChat()"><adp-label labelKey="FAQ_ReplacementDevice_P360_Answer3_ContactUs"></adp-label></button>.
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>

<ng-template #infoIcon>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1652_14961)">
      <mask id="path-1-inside-1_1652_14961" fill="white">
        <path
          d="M13.5 15.5C12.6727 15.5 12 14.8273 12 14V11.5H11.5C11.224 11.5 11 11.276 11 11C11 10.724 11.224 10.5 11.5 10.5H12C12.5513 10.5 13 10.9487 13 11.5V14C13 14.276 13.224 14.5 13.5 14.5H14C14.276 14.5 14.5 14.724 14.5 15C14.5 15.276 14.276 15.5 14 15.5H13.5Z" />
      </mask>
      <path
        d="M13.5 15.5C12.6727 15.5 12 14.8273 12 14V11.5H11.5C11.224 11.5 11 11.276 11 11C11 10.724 11.224 10.5 11.5 10.5H12C12.5513 10.5 13 10.9487 13 11.5V14C13 14.276 13.224 14.5 13.5 14.5H14C14.276 14.5 14.5 14.724 14.5 15C14.5 15.276 14.276 15.5 14 15.5H13.5Z"
        fill="currentColor" />
      <path
        d="M12 11.5H13V10.5H12V11.5ZM13.5 14.5C13.225 14.5 13 14.275 13 14H11C11 15.3796 12.1204 16.5 13.5 16.5V14.5ZM13 14V11.5H11V14H13ZM12 10.5H11.5V12.5H12V10.5ZM11.5 10.5C11.7763 10.5 12 10.7237 12 11H10C10 11.8283 10.6717 12.5 11.5 12.5V10.5ZM12 11C12 11.2763 11.7763 11.5 11.5 11.5V9.5C10.6717 9.5 10 10.1717 10 11H12ZM11.5 11.5H12V9.5H11.5V11.5ZM12 11.5H14C14 10.3964 13.1036 9.5 12 9.5V11.5ZM12 11.5V14H14V11.5H12ZM12 14C12 14.8283 12.6717 15.5 13.5 15.5V13.5C13.7763 13.5 14 13.7237 14 14H12ZM13.5 15.5H14V13.5H13.5V15.5ZM14 15.5C13.7237 15.5 13.5 15.2763 13.5 15H15.5C15.5 14.1717 14.8283 13.5 14 13.5V15.5ZM13.5 15C13.5 14.7237 13.7237 14.5 14 14.5V16.5C14.8283 16.5 15.5 15.8283 15.5 15H13.5ZM14 14.5H13.5V16.5H14V14.5Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_1652_14961)" />
      <path
        d="M12.5 8.75C12.5 8.88807 12.3881 9 12.25 9C12.1119 9 12 8.88807 12 8.75C12 8.61193 12.1119 8.5 12.25 8.5C12.3881 8.5 12.5 8.61193 12.5 8.75Z"
        fill="currentColor"
        stroke="currentColor" />
      <mask id="path-4-inside-2_1652_14961" fill="white">
        <path
          d="M12.5 20C8.08867 20 4.5 16.4113 4.5 12C4.5 7.58867 8.08867 4 12.5 4C16.9113 4 20.5 7.58867 20.5 12C20.5 16.4113 16.9113 20 12.5 20ZM12.5 5C8.64 5 5.5 8.14 5.5 12C5.5 15.86 8.64 19 12.5 19C16.36 19 19.5 15.86 19.5 12C19.5 8.14 16.36 5 12.5 5Z" />
      </mask>
      <path
        d="M12.5 20C8.08867 20 4.5 16.4113 4.5 12C4.5 7.58867 8.08867 4 12.5 4C16.9113 4 20.5 7.58867 20.5 12C20.5 16.4113 16.9113 20 12.5 20ZM12.5 5C8.64 5 5.5 8.14 5.5 12C5.5 15.86 8.64 19 12.5 19C16.36 19 19.5 15.86 19.5 12C19.5 8.14 16.36 5 12.5 5Z"
        fill="currentColor" />
      <path
        d="M12.5 19C8.64095 19 5.5 15.859 5.5 12H3.5C3.5 16.9636 7.53638 21 12.5 21V19ZM5.5 12C5.5 8.14095 8.64095 5 12.5 5V3C7.53638 3 3.5 7.03638 3.5 12H5.5ZM12.5 5C16.359 5 19.5 8.14095 19.5 12H21.5C21.5 7.03638 17.4636 3 12.5 3V5ZM19.5 12C19.5 15.859 16.359 19 12.5 19V21C17.4636 21 21.5 16.9636 21.5 12H19.5ZM12.5 4C8.08772 4 4.5 7.58772 4.5 12H6.5C6.5 8.69229 9.19229 6 12.5 6V4ZM4.5 12C4.5 16.4123 8.08772 20 12.5 20V18C9.19229 18 6.5 15.3077 6.5 12H4.5ZM12.5 20C16.9123 20 20.5 16.4123 20.5 12H18.5C18.5 15.3077 15.8077 18 12.5 18V20ZM20.5 12C20.5 7.58772 16.9123 4 12.5 4V6C15.8077 6 18.5 8.69229 18.5 12H20.5Z"
        fill="currentColor"
        mask="url(#path-4-inside-2_1652_14961)" />
    </g>
    <defs>
      <clipPath id="clip0_1652_14961">
        <rect width="16" height="16" fill="white" transform="translate(4.5 4)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #contractIcon>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1652_14983)">
      <path
        d="M7.6925 18.375H5.375C5.17609 18.375 4.98532 18.296 4.84467 18.1553C4.70402 18.0147 4.625 17.8239 4.625 17.625V4.125C4.625 3.92609 4.70402 3.73532 4.84467 3.59467C4.98532 3.45402 5.17609 3.375 5.375 3.375H19.625C19.8239 3.375 20.0147 3.45402 20.1553 3.59467C20.296 3.73532 20.375 3.92609 20.375 4.125V17.625C20.375 17.8239 20.296 18.0147 20.1553 18.1553C20.0147 18.296 19.8239 18.375 19.625 18.375H16.625"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M7.625 6.375H17.375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7.625 8.625H17.375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7.625 10.875H14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M12.125 20.625C13.989 20.625 15.5 19.114 15.5 17.25C15.5 15.386 13.989 13.875 12.125 13.875C10.261 13.875 8.75 15.386 8.75 17.25C8.75 19.114 10.261 20.625 12.125 20.625Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M10.625 17.25L11.75 18.375L13.625 16.125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1652_14983">
        <rect width="18" height="18" fill="white" transform="translate(3.5 3)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #ratingIcon>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.0941 20C16.9327 20 16.7708 19.9613 16.6261 19.8887L12.4985 17.8447L8.37428 19.8873C8.22963 19.96 8.07298 19.9973 7.91033 19.9973C7.5137 19.9973 7.1564 19.7773 6.97842 19.4233C6.86376 19.1953 6.8371 18.934 6.90243 18.688L8.13564 14.2073L4.80731 10.9107C4.61066 10.7153 4.50134 10.456 4.5 10.1787C4.49934 9.902 4.60599 9.64133 4.80064 9.444C4.97396 9.26867 5.20527 9.16133 5.45124 9.14067L9.46284 8.74333L11.5666 4.572C11.6953 4.32067 11.9119 4.136 12.1779 4.05067C12.2826 4.01667 12.3912 4 12.4999 4C12.6638 4 12.8285 4.04 12.9758 4.11533C13.1725 4.216 13.3298 4.37333 13.4298 4.57C13.4304 4.572 15.5376 8.74667 15.5376 8.74667L19.5571 9.14533C20.1204 9.192 20.5437 9.694 20.4964 10.2633C20.4757 10.5093 20.3684 10.74 20.1931 10.914L16.8674 14.21L18.1 18.6867C18.2479 19.2453 17.9166 19.8187 17.3614 19.966C17.2747 19.988 17.1847 20 17.0941 20ZM12.4985 16.7867C12.5752 16.7867 12.6525 16.8047 12.7212 16.8393L17.0727 18.994C17.0807 18.998 17.0874 19 17.0941 19C17.1274 18.9927 17.1407 18.9693 17.1347 18.9473L15.8262 14.1933C15.7782 14.0193 15.8282 13.8327 15.9562 13.7053L19.4892 10.2033C19.4952 10.1973 19.4992 10.1893 19.4998 10.1807C19.5012 10.1607 19.4858 10.1427 19.4665 10.1407L15.1656 9.71467C14.9943 9.69733 14.8463 9.596 14.7683 9.44267L12.5385 5.02333C12.5345 5.016 12.5279 5.00933 12.5192 5.00467C12.5132 5.00133 12.5059 5 12.4985 5C12.4719 5.006 12.4632 5.01333 12.4572 5.02467L10.2321 9.43933C10.1548 9.59267 10.0061 9.69467 9.8348 9.712L5.5419 10.1373C5.52057 10.1387 5.51323 10.146 5.51123 10.148C5.5039 10.1553 5.50057 10.164 5.50057 10.174C5.50057 10.184 5.5039 10.1927 5.51123 10.1993L9.04688 13.7013C9.17486 13.828 9.22486 14.0147 9.17686 14.1893L7.867 18.948C7.86566 18.952 7.86566 18.9627 7.871 18.974C7.87966 18.9907 7.89699 18.9967 7.90899 18.9967C7.91566 18.9967 7.92166 18.9953 7.92699 18.9927L12.2759 16.8387C12.3445 16.8047 12.4219 16.7867 12.4985 16.7867Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #shieldIcon>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1652_14971)">
      <path
        d="M20.0875 3.97473C17.6951 2.93048 15.1103 2.39961 12.5 2.4164C9.89108 2.40019 7.30775 2.93105 4.91664 3.97473C4.69198 4.0767 4.50162 4.24151 4.36853 4.44926C4.23545 4.65702 4.16534 4.89885 4.16664 5.14557V11.5097C4.16653 13.5796 4.79374 15.6009 5.96558 17.3071C7.13742 19.0133 8.79886 20.3243 10.7308 21.0672L11.6258 21.4122C12.1871 21.6393 12.8146 21.6393 13.3758 21.4122L14.2708 21.0672C16.2025 20.3241 17.8635 19.0129 19.0351 17.3068C20.2066 15.6006 20.8336 13.5794 20.8333 11.5097V5.14557C20.835 4.8993 20.7655 4.6578 20.6332 4.45009C20.5009 4.24238 20.3114 4.07731 20.0875 3.97473V3.97473Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M17.6933 14.1723L8.91162 5.39062" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.66663 7.52148L15.8066 16.6615" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M17.8141 5.99958C16.1369 5.2743 14.3273 4.9054 12.5 4.91625C10.6727 4.9054 8.86305 5.2743 7.18581 5.99958C7.03004 6.07086 6.89818 6.18562 6.80608 6.33005C6.71398 6.47449 6.66556 6.64245 6.66664 6.81375V11.2412C6.67395 12.6844 7.11738 14.0916 7.93874 15.2782C8.76011 16.4648 9.92102 17.3754 11.2691 17.8904L11.8916 18.1304C12.2818 18.2882 12.7181 18.2882 13.1083 18.1304L13.7308 17.8904C15.0789 17.3754 16.2398 16.4648 17.0612 15.2782C17.8826 14.0916 18.326 12.6844 18.3333 11.2412V6.81375C18.3344 6.64245 18.286 6.47449 18.1939 6.33005C18.1018 6.18562 17.9699 6.07086 17.8141 5.99958V5.99958Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1652_14971">
        <rect width="20" height="20" fill="white" transform="translate(2.5 2)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
